import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link } from 'react-router';
import { TABS_HEIGHT } from 'utils/ui/constants.js';

// Styled Components
const StyledTab = styled(Tab)({
    fontSize: '0.65rem',
    height: TABS_HEIGHT,
    minHeight: TABS_HEIGHT,
    minWidth: 72
});

const StyledTabs = styled(Tabs)({
    height: TABS_HEIGHT,
    minHeight: TABS_HEIGHT
});

// Scroll to a section smoothly
const scrollTo = id => {
    const element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
};

const Component = ({ currentTab, elevation, tabs }) => {
    const [stateSelectedTab, setTab] = useState(0);
    let selectedTab, onChange;

    if (currentTab) {
        selectedTab = tabs.findIndex(tab => tab.id === currentTab);
        if (selectedTab === -1) {
            selectedTab = 0;
        }
    } else {
        selectedTab = stateSelectedTab;
        onChange = (_, index) => {
            setTab(index);
            scrollTo(tabs[index].id);
        };
    }

    const TabsList = tabs.map(tab =>
        tab.url ? (
            <StyledTab component={Link} key={tab.id} label={tab.text} to={tab.url}/>
        ) : (
            <StyledTab key={tab.id} label={tab.text}/>
        )
    );

    return (
        <Paper elevation={elevation} square>
            <StyledTabs
                indicatorColor="primary"
                onChange={onChange}
                textColor="primary"
                value={selectedTab}
            >
                {TabsList}
            </StyledTabs>
        </Paper>
    );
};

// PropTypes
Component.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired,
            url: PropTypes.string // Optional URL
        })
    ).isRequired,
    elevation: PropTypes.number,
    currentTab: PropTypes.string
};

export default Component;
